import { render, staticRenderFns } from "./GlossaryEntry.vue?vue&type=template&id=0c15baee&scoped=true"
import script from "./GlossaryEntry.vue?vue&type=script&lang=js"
export * from "./GlossaryEntry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c15baee",
  null
  
)

export default component.exports